import { CalendarSource } from './CalendarSource';

class AppStore {
    myMunyiCalendar = new CalendarSource(); // Data store for "My Calendar"
    dayTypesCalendar = new CalendarSource(); // Data store for "Administration/Day types"
    contentEventCalendar = new CalendarSource(); // Data store for cms.content events    
}

export const appStore = new AppStore();